<template>
  <el-dialog
    title="新增用户"
    :visible.sync="visible"
    width="480px"
    @close="reset"
    :close-on-click-modal="false"
    custom-class="pub_dialog"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="用户名" label-width="80px" prop="userName">
        <el-input
          v-model="form.userName"
          autocomplete="off"
          placeholder="请输入邮箱地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" label-width="80px" prop="passWord">
        <el-input
          v-model="form.passWord"
          autocomplete="off"
          placeholder="请输入账号密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="使用者" label-width="80px" prop="operator">
        <el-input
          v-model="form.operator"
          autocomplete="off"
          placeholder="请输入使用者姓名"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="submit('form')" :loading="loading">{{
        loading ? "注册中" : "注册"
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { email, password } from "@/utils/regexp.js";
import register from "@/api/register.js";
export default {
  data() {
    var rule_pw = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不得为空！"));
      } else {
        if (!password.test(value)) {
          return callback(new Error("密码至少6位且不能包含空格"));
        }
        callback();
      }
    };
    var rule_at = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("账号不得为空！"));
      } else {
        if (!email.test(value)) {
          return callback(new Error("请输入正确邮箱"));
        }
        callback();
      }
    };
    return {
      form: {
        userName: "",
        passWord: "",
        operator: "",
      },
      rules: {
        userName: [{ required: true, validator: rule_at, trigger: "blur" }],
        passWord: [{ required: true, validator: rule_pw, trigger: "blur" }],
        operator: [
          { required: true, message: "姓名不得为空！", trigger: "blur" },
          { min: 1, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
      visible: false,
      loading: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let res = await register(this.form);
          this.isLoading = false;
          if (res === "ok") {
            this.$message({
              showClose: true,
              type: "success",
              message: "新增用户成功",
            });
            this.loading = false;
            this.visible = false;
            this.$listeners.getData();
          }
        } else {
          return false;
        }
      });
    },
    reset(done) {
      this.loading = false;
      this.$refs.form.resetFields();
      done();
    },
  },
};
</script>

<style></style>
